"use client"

/**
 * Sticky form action bar (Lane D).
 *
 * Lives inside FormShell's `actionBar` slot. Hosts the autosave
 * indicator on the left and primary/secondary actions on the right.
 *
 * Caller assembles their own buttons (Lưu nháp / Xem trước / Xuất bản
 * / Cập nhật) since each module has different action semantics.
 */

import { ReactNode } from "react"

interface StickyActionBarProps {
  /** Left slot — usually <AutosaveIndicator/>. */
  left?: ReactNode
  /** Right slot — primary + secondary buttons. */
  right: ReactNode
}

export function StickyActionBar({ left, right }: StickyActionBarProps) {
  return (
    <div
      className="flex items-center justify-between"
      style={{ width: "100%", gap: 16 }}
    >
      <div className="flex items-center gap-3" style={{ minWidth: 0, flex: "1 1 auto" }}>
        {left}
      </div>
      <div className="flex items-center gap-2" style={{ flexShrink: 0 }}>
        {right}
      </div>
    </div>
  )
}

export default StickyActionBar
